(() => {
  const roots = [['.ploy-home-body', 'ploy-native'], ['.ploy-page-island', 'ploy-pages'], ['#MainContent .pp', 'ploy-product']];
  const seen = new WeakSet();
  let nextId = 0;
  function mount() {
    for (const [selector, layer] of roots) for (const root of document.querySelectorAll(selector)) {
      if (seen.has(root)) continue;
      seen.add(root);
      const sheet = document.createElement('style');
      sheet.dataset.ployInlineSheet = layer;
      // Page-island CSS can live in the body; declare inline after its layers.
      root.after(sheet);
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const rules = [];
        for (const element of [root, ...root.querySelectorAll('[style]')]) {
          if (!element.style.length) continue;
          element.dataset.ployInline ||= String(++nextId);
          const declarations = Array.from(element.style).map(property => {
            const value = element.style.getPropertyValue(property).replace(/(-?\d*\.?\d+)rem\b/g, (_, number) => `${Number(number) * 16}px`);
            return `${property}:${value}!important`;
          }).join(';');
          rules.push(`[data-ploy-inline="${element.dataset.ployInline}"]{${declarations}}`);
        }
        // Inline state belongs above normal source rules, below source !important.
        const css = `@layer ${layer}.inline{${rules.join('')}}`;
        if (sheet.textContent !== css) sheet.textContent = css;
      };
      update();
      const hasStyles = node => node.nodeType === 1 && (node.matches('[style], [data-ploy-inline]') || node.querySelector('[style], [data-ploy-inline]'));
      new MutationObserver(records => {
        const changed = records.some(record => record.type === 'attributes' || [...record.addedNodes, ...record.removedNodes].some(hasStyles));
        if (!changed || scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      }).observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['style']});
    }
  }
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
